import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

/**
 * Descarga un documento almacenado en blob-storage autenticado
 * @param {string} path
 * @returns {Promise<{blob: Blob, contentType: string} | null>}
 */
export async function downloadDocument(path) {
  if (!path) return null;
  try {
    const resp = await getAPIResponse(`/v1/blob-storage/${encodeURIComponent(path)}`, {}, 'GET', true, 'blob');
    if (!resp || !resp.data) return null;
    const contentType = resp.headers?.['content-type'] || '';
    return { blob: resp.data, contentType };
  } catch (e) {
    return null;
  }
}
